export default {
    init(authBase) {
      const requestCall = authBase;
      return {
        submitData(requestPayload) {
          return requestCall.submitRecommendForm(requestPayload);
        }
      };
    },
  };
  